import type { BuzzRow } from './view';

interface Props {
  buzzes: readonly BuzzRow[];
  activeParticipantId: string | null;
  /** Host only: hand the buzz to someone out of order. */
  onPick?: (participantId: string) => void;
}

/**
 * Buzz-in order, first to last. The gap shown is measured from the leader's
 * server-arrival time, which is the only ordering anyone can argue with.
 */
export function BuzzList({ buzzes, activeParticipantId, onPick }: Props) {
  if (buzzes.length === 0) {
    return <p className="faint">No buzzes yet.</p>;
  }

  return (
    <ol className="buzz-list">
      {buzzes.map((buzz) => (
        <li
          key={buzz.participantId}
          className={[
            buzz.participantId === activeParticipantId ? 'is-active' : '',
            buzz.verdict === 'correct' ? 'is-correct' : '',
            buzz.verdict === 'incorrect' ? 'is-incorrect' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <span className="buzz-order">{buzz.order}</span>
          <span className="buzz-name">{buzz.name}</span>
          {buzz.verdict ? (
            <span className={`tag ${buzz.verdict === 'correct' ? 'tag-good' : 'tag-bad'}`}>
              {buzz.verdict}
            </span>
          ) : null}
          <span className="buzz-delta">
            {buzz.order === 1 ? 'first' : `+${buzz.deltaMs.toFixed(0)} ms`}
          </span>
          {onPick && !buzz.verdict && buzz.participantId !== activeParticipantId ? (
            <button className="btn btn-sm" onClick={() => onPick(buzz.participantId)}>
              Give buzz
            </button>
          ) : null}
        </li>
      ))}
    </ol>
  );
}
